import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-oops-page',
  templateUrl: './oops-page.component.html',
  styleUrls: ['./oops-page.component.scss']
})
export class OopsPageComponent {}
